import AppContainer from '~/containers/AppContainer/AppContainer';
import { Careers } from '~/components/views/Careers';
import HeaderMetaTags from '~/components/modules/Header/HeaderMetaTags';
import { useRouter } from 'next/router';

export default function CareersPage() {
    const router = useRouter();
    return (
        <AppContainer>
            <HeaderMetaTags
                url={`${process.env.NEXT_PUBLIC_HOST_ENV}${router.asPath}`}
                title={'Careers with Vinovest'}
                description={
                    'Explore the career opportunities at Vinovest and the unique perks of joining the world-class team.'
                }
                canonical
            />
            <Careers />
        </AppContainer>
    );
}
